import { createContext } from "react";

const doctorContext = createContext();

export default doctorContext;